import React, { useState } from "react";
import logo from "../logo.png";
import styled from "styled-components";
import { CgMenuRightAlt } from "react-icons/cg";
import { TfiClose } from "react-icons/tfi";
import {
  motion,
  useScroll,
  useTransform,
  AnimatePresence,
} from "framer-motion";
import { Link } from "react-scroll";
import { useMediaQuery } from "react-responsive";

const NavBar = () => {
  const isCpu = useMediaQuery({ minWidth: 768 });
  const { scrollY } = useScroll();
  const scaleY = useTransform(
    scrollY,
    [0, 500],
    [isCpu ? 100 : "10vh", isCpu ? 75 : "7vh"]
  );
  const [focused, setFocused] = useState(null);
  const [open, setOpen] = useState(false);
  const tabs = ["portfolio", "prestations", "contact"];
  const handleClose = () => {
    setOpen(false);
    setFocused(null);
  };
  return (
    <Nav
      initial={{ opacity: 0 }}
      animate={{
        opacity: [0, 1],
        transition: { duration: 1.5, ease: "easeIn" },
      }}
    >
      <UlMain>
        <Li className="logo">
          <A
            to="home"
            smooth={true}
            duration={500}
            activeClass="logoEffect"
            spy={true}
          >
            <motion.img
              src={logo}
              alt="logo"
              style={{ height: scaleY, transformOrigin: "top" }}
            />
          </A>
        </Li>
        <Li
          onMouseEnter={isCpu ? () => setOpen(true) : null}
          onClick={isCpu ? null : () => setOpen(true)}
        >
          <CgMenuRightAlt
            color="white"
            size={40}
          />
        </Li>
      </UlMain>
      <AnimatePresence>
        {open && (
          <UlSecond
            onMouseLeave={isCpu ? () => setOpen(false) : null}
            onClick={isCpu ? null : () => setOpen(false)}
            initial={{ opacity: 0.5 }}
            animate={{ opacity: 1, transition: { duration: 0.3 } }}
            exit={{ opacity: 0 }}
          >
            <motion.div onMouseLeave={() => setFocused(null)}>
              {tabs.map((tab) => (
                <Li
                  key={tab}
                  onMouseEnter={() => setFocused(tab)}
                >
                  <A
                    onClick={handleClose}
                    to={tab}
                    smooth={true}
                    duration={1000}
                    activeClass="active"
                    spy={true}
                    offset={-70}
                  >
                    {tab}
                  </A>
                  {focused === tab ? (
                    <motion.div
                      className="hover"
                      layoutId="highlight"
                      transition={{
                        layout: {
                          duration: 0.1,
                          ease: "easeInOut",
                        },
                      }}
                    />
                  ) : null}
                </Li>
              ))}
            </motion.div>
            <Li
              onMouseEnter={isCpu ? () => setOpen(false) : null}
              onClick={isCpu ? null : () => setOpen(false)}
            >
              <TfiClose
                size={30}
                className="close"
              />
            </Li>
          </UlSecond>
        )}
      </AnimatePresence>
    </Nav>
  );
};

export default NavBar;

const Nav = styled(motion.nav)`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  letter-spacing: 2px;
  z-index: 20;
`;

const UlMain = styled.ul`
  margin: 0 5vw;
  width: 100%;
  list-style: none;
  display: flex;
  justify-content: center;

  li:nth-of-type(2) {
    margin: 20px 0;
    margin-left: auto;
  }
  li.logo {
    position: absolute;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.8);
    transition: background 0.3s ease-out;
    padding-top: 5px;
    width: 75px;
    height: 75px;
    margin-top: 3vh;
    @media (max-width: 768px) {
      width: 7vh;
      height: 7vh;
    }
  }
  .logo:has(.logoEffect) {
    background: none;
  }
`;

const UlSecond = styled(motion.ul)`
  position: fixed;
  inset: 0 0 0 60vw;
  background: rgba(0, 0, 0, 1);
  list-style: none;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  @media (max-width: 768px) {
    inset: 0 0 0 0;
  }
  animation: clipPath 1s ease-out;
  @keyframes clipPath {
    0% {
      clip-path: circle(0% at 100% 0%);
    }
    100% {
      clip-path: circle(140% at 100% 0%);
    }
  }
  li {
    margin: 20px 0;
    .close {
      position: absolute;
      bottom: -15vh;
      z-index: 20;
      color: white;
    }
  }
`;

const Li = styled(motion.li)`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  .active {
    color: #8f601a;
  }
  .hover {
    position: absolute;
    background: rgba(255, 255, 255, 0.1);
    width: 100%;
    height: 100%;
    border-radius: 0.5rem;
    z-index: -1;
  }
`;

const A = styled(Link)`
  padding: 0.5rem 1rem;
  position: relative;
  color: #fff;
  text-decoration: none;
  cursor: pointer;
  font-weight: 100;
  text-shadow: 0 0 10px rgb(0, 0, 0);
  text-transform: capitalize;
`;
